/* eslint-disable indent */
import { ImageLoader, Preloader } from 'components/common';
import { ACCOUNT_EDIT } from 'constants/routes';
import { displayDate, getHeader, apiUrl } from 'helpers/utils';
import PropType from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, withRouter } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import moment from 'moment';
import { Elements } from '@stripe/react-stripe-js';
import {
  useUser
} from 'hooks';
import CurrencyInput from 'react-currency-input-field';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { BrowserPayCheckout } from '../../components/checkoutForm/BrowserPayCheckout';
import { CardCheckout } from '../../components/checkoutForm/CardCheckout';
import {
 Header, Item, Main, Modal
} from './styles';
import { updateRegistry } from '../../redux/actions/registryActions';
import CheckoutForm from '../../components/checkoutForm';

const maybePluralize = (count, noun, suffix = 's') => `${noun}${count !== 1 ? suffix : ''}`;
const stripePromise = loadStripe('pk_test_51IaUAiFMaDEaYlf5CuLuN1bmfv3lsGvoLQNhYpP9ryH2CC9ZJjyOxl1zgrteSIAFP9evOY2SxneVU4aW38DECtZV00UiMXUBkz');


const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '12rem',
    marginBottom: '30px'
  },
  nextButton: {
    margin: 'auto',
    marginBottom: '8px'
  },
  start: {
    display: 'grid',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    /* bring your own prefixes */
    transform: 'translate(-50%, -50%)'
  },
  shop: {
    marginBottom: '30px',
    display: 'contents',
    marginTop: '100px',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    /* bring your own prefixes */
    transform: 'translate(-50%, -50%)'
  },
  title: {
    fontFamily: 'raleway',
    color: '#36b0c9',
    display: 'grid',
    justifyContent: 'center',
    marginTop: '100px'
  },
  donateTitle: {
    fontFamily: 'raleway',
    color: '#36b0c9',
    display: 'grid',
    justifyContent: 'center'
  },
  subtitle: {
    fontFamily: 'raleway',
    display: 'grid',
    textAlign: 'center',
    fontWeight: '400'
  }
}));

const styles = {
  noteCont: {
    marginBottom: '70px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 12vw'
  },
  countCont: {
    margin: '0 12vw',
    marginBottom: '2vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  countdownWrap: {
    width: '100%',
    // border: '1px solid black',
    padding: '50px',
    backgroundColor: '#ffc56d',
    borderRadius: '30px',
    fontFamily: 'arial',
    maxWidth: '650px',
    flexDirection: 'row',
    margin: 'auto',
    marginTop: '20px'
  },
  goal: {
    fontSize: '48px',
    textAlign: 'right',
    color: '#36b0c9',
    '@media only screen and(maxWidth: 640px)': {
      textAlign: 'center'
    }
  },
  glass: {
    width: '100%',
    height: '20px',
    background: '#415364',
    borderRadius: '10px',
    float: 'left',
    overflow: 'hidden'
  },
  progress: {
    float: 'left',
    width: '16%',
    height: '20px',
    background: '#36b0c9',
    zIndex: 333
    // borderRadius: '5px',
  },
  goalStat: {
    width: '25%',
    // height: '30px',
    padding: '10px',
    float: 'left',
    margin: 0,
    color: '#fff',
    '@media only screen and(maxWidth: 640px)': {
      width: '50%',
      textAlign: 'center'
    }
  },
  block: {
    display: 'block'
  },
  goalLabel: {
    composes: '$block'
  },
  goalLabelHighlight: {
    composes: '$block'
  },
  goalNumber: {
    composes: '$block',
    color: '#36b0c9',
    fontWeight: 'bold'
  },
  goalNumberHighlight: {
    composes: '$block',
    fontWeight: 'bold'
  },
  shoop: {
    width: '50px'
  }
};


const defaultAvatar = require('../../images/defaultAvatar.png');

const UserProfile = () => {
  const { id } = useParams();
  const { user, isLoading, error } = useUser(id);
  const {
    banner,
    firstName,
    lastName,
    avatar,
    registry,
    fundGoal,
    note,
    address,
    stripeAccountId,
    email
  } = user;

  const [stateRegistry, setStateRegistry] = useState(registry);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [className, setClassName] = useState('');
  const [sendFund, setSendFund] = useState(0);
  const [daysLeft, setDaysLeft] = useState(null);
  const [rawValue, setRawValue] = useState(' ');
  const [intendToDonate, setIntendToDonate] = useState(false);
  const [clientSecret, setClientSecret] = useState('');
  const [stateFundAmount, setStateFundAmount] = useState(0);
  const [stateFundContributors, setStateFundContributors] = useState([]);


  const dispatch = useDispatch();

  const classes = useStyles();
  const limit = 10000000000000000;
  const prefix = '$';

  useEffect(() => {
    if (user.firstName) {
      if (user.fundGoalDate) {
        const start = moment();
        const end = moment(user.fundGoalDate.toDate())
        setDaysLeft(Math.round(moment.duration(end.diff(start)).asDays()));
        setStateFundAmount(user.fundAmount);
        setStateFundContributors(user.fundContributors);
      }
      setStateRegistry(registry);
    }
  }, [user]);


  const handleOnValueChange = (value) => {
    setRawValue(value === undefined ? 'undefined' : value || ' ');
  };

  const handleSubmitValueChange = async (value) => {
    if (!value) {
      setClassName('');
      setSendFund('');
      return;
    }

    if (Number.isNaN(Number(value))) {
      setErrorMessage('Please enter a valid number');
      setClassName('is-invalid');
      return;
    }

    if (Number(value) > limit) {
      setErrorMessage(`Max: ${prefix}${limit}`);
      setClassName('is-invalid');
      setSendFund(value);
      return;
    }
    const amount = Math.round(100 * parseFloat(typeof value === 'string' ? value.replace(/[$,]/g, '') : value));
    const response = await fetch(`${apiUrl}/create-payment-intent`,
        {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          headers: {
            'Content-Type': 'application/json'
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({ amount, stripeAccountId }) // body data type must match "Content-Type" header
        });
    const { clientSecret } = await response.json();
    setClientSecret(clientSecret);

    setClassName('is-valid');
    setSendFund(value);
    setRawValue(0);
  };


  return (
    <>
      { isLoading
          ? (
            <div style={{ minWidth: '100%' }}>
              <Preloader />
            </div>
) : (
  <div className="page-container">
    {banner
                  && (
                  <Header background={getHeader(banner)}>
                    <div>
                      <a>
                        <h1>{`${firstName} ${lastName}'s`}</h1>
                        <h1>Breakup Registry</h1>
                        <ImageLoader
                          alt="Avatar"
                          className="user-profile-img-2"
                          src={avatar || defaultAvatar}
                        />

                      </a>
                    </div>
                    {/* <div> */}
                    {/*  <button className="search" type="button" onClick={onClickToggleSearchModal}>Add Item</button> */}
                    {/*  <button className="import" type="button" onClick={onClickToggleImportModal}>Import Amazon Wishlist</button> */}
                    {/* </div> */}
                  </Header>
)}
    <Main>
      {note && (
      <div style={styles.noteCont}>
        <h1 className="note-titles">Welcome to my registry!</h1>
        <h3 style={{ whiteSpace: 'pre-line', marginBottom: '50px' }}>{note.replace(/<br \/>/g, '\n')}</h3>
      </div>
)}
      {fundGoal
                  && (
                    <>
                      <div style={styles.countCont}>
                        <h1 className="note-titles">Help me with funds</h1>
                        <div style={styles.countdownWrap}>
                          <h1 className="goal-titles">My Goal</h1>
                          <div style={styles.goal}>{`$${fundGoal}`}</div>
                          <div style={styles.glass}>
                            <div style={{
                              float: 'left',
                              width: `${Math.floor((stateFundAmount / fundGoal) * 100)}%`,
                              height: '20px',
                              background: '#36b0c9',
                              zIndex: 333
                              // borderRadius: '5px',
                            }}
                            />
                          </div>
                          <div style={styles.goalStat}>
                            <span style={styles.goalNumber}>{`${Math.floor((stateFundAmount / fundGoal) * 100)}% `}</span>
                            <span style={styles.goalLabel}>Funded</span>
                          </div>
                          <div style={styles.goalStat}>
                            <span style={styles.goalNumber}>{`$${stateFundAmount} `}</span>
                            <span style={styles.goalLabel}>Raised</span>
                          </div>
                          {
                            !!daysLeft && (
                            <div style={styles.goalStat}>
                              <span style={styles.goalNumber}>
                                <div id="countdown">{daysLeft}</div>
                              </span>
                              <span style={styles.goalLabel}>{Number(daysLeft) > 1 ? 'Days Left' : 'Day left!'}</span>
                            </div>
)
}
                          <div style={styles.goalStat}>
                            <span style={styles.goalNumber}>{`${stateFundContributors.length} `}</span>
                            <span style={styles.goalLabel}>{maybePluralize(stateFundContributors.length, 'Funder', 's')}</span>
                          </div>
                        </div>
                      </div>
                      {clientSecret ? (
                        <div className="stripe-wrapper">
                          <Elements stripe={stripePromise}>
                            {/* <BrowserPayCheckout amount={Number(sendFund)} /> */}
                            {/* <CardCheckout amount={Number(sendFund)} /> */}
                            <CheckoutForm
                              amount={Number(sendFund)}
                              clientSecret={clientSecret}
                              email={email}
                              fundAmount={stateFundAmount}
                              fundContributors={stateFundContributors}
                              setStateFundAmount={setStateFundAmount}
                              stripeAccountId={stripeAccountId}
                              setStateFundContributors={setStateFundContributors}
                              id={id}
                              setClientSecret={setClientSecret}
                            />
                            <p className="disclaimer">* Stripe takes 2.9% of the purchase + $0.30 per transaction and MBUR takes 1.8%</p>
                          </Elements>
                        </div>
) : (
  <div className="fundy">
    { intendToDonate ? (
      <div className={classes.shop}>
        <h2 className={classes.donateTitle}>How much would you like to donate?</h2>

        <form className="needs-validation">
          <div className="row">
            <div className="donate-input">
              <CurrencyInput
                id="validationCustom01"
                name="input-1"
                width="60px"
                className={`form-control ${className} donate`}
                value={rawValue}
                onValueChange={handleOnValueChange}
                onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmitValueChange(rawValue);
                      }}
                placeholder="Please enter a number"
                prefix={prefix}
                step={1}
                decimalScale={2}
              />
              <div className="donate-button">
                <button
                  className="stripe"
                  onClick={(e) => {
                        e.preventDefault();
                        handleSubmitValueChange(rawValue);
                      }}
                >
                  donate
                </button>
              </div>
            </div>

            <div className="invalid-feedback">{errorMessage}</div>
          </div>
        </form>
      </div>
) : (
  <button
    className="onboard-button"
    color="primary"
    type="submit"
    onClick={() => setIntendToDonate(true)}
  >
    Help Fund My Goal
  </button>
    )}
  </div>
)}
                    </>
)}
      {stateRegistry && stateRegistry.length > 0 && (
        <section className="user-registry">
          <h1 className="note-titles">My Registry</h1>
          <h3 style={{
 whiteSpace: 'pre-line', marginBottom: '50px', width: '100%', marginLeft: '20px'
}}
          >
            {`Please ship to: ${address}`}
          </h3>
          {stateRegistry.map((i, k) => (
            <Item key={`Item-${k}`}>
              {/* <dl> */}
              {/*  <dt>...</dt> */}
              {/*  <dd onClick={deleteItem(k)}>Delete</dd> */}
              {/* </dl> */}
              <span>
                $
                {i.price}
              </span>
              <img alt={i.name} src={i.image} />
              <h3>{i.name}</h3>
              <a
                href={`https://www.amazon.com${i.url}`}
                target="_blank"
                className={i.bought ? 'bought-a' : 'not-bought-a'}
                rel="noopener noreferrer"
                onClick={() => {
                  setTimeout(() => {
                    const updatedStateRegistry = [...stateRegistry];
                    updatedStateRegistry[k].bought = true;
                    setStateRegistry(updatedStateRegistry);
                    dispatch(updateRegistry({ registry: updatedStateRegistry }));
                    alert(`Thank you for purchasing ${i.name} for ${firstName}`);
                  }, 2000);
                }}
              >
                {i.bought ? 'Bought' : 'Buy'}
              </a>
            </Item>
            ))}
        </section>
      )}
    </Main>

    <Modal show={false}>
      {/* <div> */}
      {/*  <button type="button" className="modal-close-button" onClick={onClickToggleSearchModal}>&times;</button> */}
      {/*  <h1>Add Item</h1> */}
      {/*  <input */}
      {/*    onSubmit={(e) => { e.preventDefault(); }} */}
      {/*    disabled={fetching} */}
      {/*    type="search" */}
      {/*    value={search} */}
      {/*    onChange={onChangeSearch} */}
      {/*    onKeyDown={handleKeyDownSearch} */}
      {/*        // onKeyUp={onKeyUpSearch} */}
      {/*    placeholder="Search for products" */}
      {/*  /> */}
      {/*  <button className="importButton" type="button" onClick={onKeyUpSearch}>search</button> */}
      {/*  <section> */}
      {/*    {fetching && ( */}
      {/*      <div> */}
      {/*        <svg */}
      {/*          xmlns="http://www.w3.org/2000/svg" */}
      {/*          width="38" */}
      {/*          height="38" */}
      {/*          viewBox="0 0 38 38" */}
      {/*          stroke="#666666" */}
      {/*        > */}
      {/*          <g fill="none"> */}
      {/*            <g transform="translate(1 1)" strokeWidth="2"> */}
      {/*              <circle strokeOpacity=".5" cx="18" cy="18" r="18" /> */}
      {/*              <path */}
      {/*                d="M36 18c0-9.94-8.06-18-18-18" */}
      {/*                transform="rotate(277.527 18 18)" */}
      {/*              > */}
      {/*                <animateTransform */}
      {/*                  attributeName="transform" */}
      {/*                  type="rotate" */}
      {/*                  from="0 18 18" */}
      {/*                  to="360 18 18" */}
      {/*                  dur="1s" */}
      {/*                  repeatCount="indefinite" */}
      {/*                /> */}
      {/*              </path> */}
      {/*            </g> */}
      {/*          </g> */}
      {/*        </svg> */}
      {/*      </div> */}
      {/*      )} */}
      {/*    {!fetching */}
      {/*      && searchResults */}
      {/*      && searchResults.length > 0 */}
      {/*      && searchResults.map((i, k) => ( */}
      {/*        <article key={`stateRegistry-${k}`}> */}
      {/*          <div> */}
      {/*            <img alt={i.name} src={i.image} /> */}
      {/*          </div> */}
      {/*          <h3>{i.name}</h3> */}
      {/*          <span> */}
      {/*            $ */}
      {/*            {i.price} */}
      {/*          </span> */}
      {/*          <button type="button" onClick={addItem(i)}>+</button> */}
      {/*        </article> */}
      {/*      ))} */}
      {/*  </section> */}
      {/* </div> */}
    </Modal>
  </div>
)}
    </>
  );
};

UserProfile.propTypes = {
  history: PropType.shape({
    push: PropType.func
  }).isRequired
};

export default withRouter(UserProfile);
